module.exports = [{"지역":"서울특별시의 대학","갯수":70},{"지역":"대전광역시의 대학","갯수":23}]


//////////////////
// WEBPACK FOOTER
// ./js/examples/data/university.json
// module id = 494
// module chunks = 17